import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class HttpService {
  constructor(private httpClient: HttpClient) { }

  private request<T>(method: string, url: string, data?: any) {
    return new Promise<T>((resolve, reject) => {
      this.httpClient.request<T>(method, url, {
        body: data
      }).toPromise().then(r => {
        resolve(<any>r);
      }).catch(e => {
        reject(e);
      });
    });
  }

  get<T>(url: string) {
    return this.request<T>('GET', url);
  }

  put(url: string, data: any) {
    return this.request<void>('PUT', url, data);
  }

  post<T>(url: string, data: any) {
    return this.request<T>('POST', url, data);
  }

  delete(url: string) {
    return this.request<void>('DELETE', url);
  }
}
